import IfGlobalOrg from '@/components/organizations/IfGlobalOrg'
import { AdminHeaderActionButton } from '@/components/patterns/admin-page'
import { usePathHelper } from '@/hooks/usePathHelper'
import { Link } from '@tanstack/react-router'
import { Bookmark } from 'lucide-react'

export function SavedPosCartsLink({ orgId }: { orgId: string | number }) {
  const path = usePathHelper()

  return (
    <IfGlobalOrg show={false}>
      <AdminHeaderActionButton variant="outline" asChild>
        <Link {...path.drafts.index().using({ orgId }).link}>
          <Bookmark />
          Draft Orders
        </Link>
      </AdminHeaderActionButton>
    </IfGlobalOrg>
  )
}
